import * as React from "react";
import { useCallback, useMemo } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import fieldTypeFor from "views/logic/fieldtypes/FieldTypeFor";
import collectKeysByType from "views/components/visualizations/keyMappers/collectKeysByType";
import KeyMapperContext from "./KeyMapperContext";
const KeyMapperProvider = ({ data, config, fields, children }) => {
  const bindings = usePluginEntities("visualizationKeyMappers");
  const relevantTypes = useMemo(() => new Set((bindings != null ? bindings : []).map((binding) => binding.type)), [bindings]);
  const fieldTypeOf = useCallback((field) => {
    var _a;
    return (_a = fieldTypeFor(field, fields)) == null ? void 0 : _a.type;
  }, [fields]);
  const keysByType = useMemo(
    () => collectKeysByType(data, config, fieldTypeOf, relevantTypes),
    [data, config, fieldTypeOf, relevantTypes]
  );
  const mappers = (bindings != null ? bindings : []).map((binding) => {
    var _a;
    return binding.useKeyMapper((_a = keysByType[binding.type]) != null ? _a : []);
  });
  const mapperByType = Object.fromEntries(
    (bindings != null ? bindings : []).map((binding, idx) => [binding.type, mappers[idx]])
  );
  const fieldTypeByName = useMemo(() => {
    var _a, _b;
    const pivotFields = [
      ...((_a = config == null ? void 0 : config.rowPivots) != null ? _a : []).flatMap((pivot) => pivot.fields),
      ...((_b = config == null ? void 0 : config.columnPivots) != null ? _b : []).flatMap((pivot) => pivot.fields)
    ];
    return Object.fromEntries(pivotFields.map((name) => [name, fieldTypeOf(name)]));
  }, [config, fieldTypeOf]);
  const mapKeys = (key, field) => {
    var _a, _b;
    const type = fieldTypeByName[field];
    return (_b = type ? (_a = mapperByType[type]) == null ? void 0 : _a.call(mapperByType, key) : void 0) != null ? _b : key;
  };
  return /* @__PURE__ */ React.createElement(KeyMapperContext.Provider, { value: mapKeys }, children);
};
export default KeyMapperProvider;
